///<reference path='../salesForceTrackingPixel/baseTracking.class.ts'/>
'use strict';

namespace Core {

    class Bd4PageTracking extends Core.BaseTracking  {
        constructor (
            $scope: ng.IScope,
            $rootScope: ng.IRootScopeService,
            $q: ng.IQService,
            $location: ng.ILocationService,
            private bd4t: any
        ) {
            super($scope, $rootScope, $q, $location);
        }

        $onInit(): void {
            this._onInit();
        }

        protected notChangedRouteHandler(): void {
        }

        protected notTrackedRouteHandler(): void {
        }

        protected routeChanged(page: Core.IPageTrackingData): void {

        }

        protected cmsRouteChanged(page: Core.IPageTrackingData): void {
            if (this.$location.path() === '/') {
                this.bd4t('initPage', {type: 'home', section: 'home'});
            } else {
                this.bd4t('initPage', {type: 'generic', section: 'package'});
            }
            this.bd4t('send', 'pageview');
        }
    }

    angular
        .module('core')
        .directive('bdfourPageTracking', (): ng.IDirective => {
            return {
                restrict: 'E',
                controller: Bd4PageTracking,
                controllerAs: 'bd4Tracking',
                template: ''
            };
        });
}
